import { NumericFormat, PatternFormat } from "react-number-format";

type PropsType = {
  value: string | number;
};

export const MoneyField = (props: PropsType) => {
  return (
    <NumericFormat
      value={props.value}
      displayType="text"
      thousandSeparator="."
      decimalSeparator=","
      prefix="R$ "
      decimalScale={2}
      fixedDecimalScale={true}
    />
  );
};

export const DecimalField = (props: PropsType) => {
  return (
    <NumericFormat
      value={props.value}
      displayType="text"
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale={true}
    />
  );
};

export const CompanyDocument = (props: PropsType) => {
  return (
    <PatternFormat
      displayType="text"
      value={props.value}
      format="##.###.###/####-##"
    />
  );
};
